module.exports = __webpack_public_path__ + "static/img/3-3.be96630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/3-3.png
// module id = RRVT
// module chunks = 1